<template>
  <div class="">
    <div v-click-outside="() => focused = false" class="SEARCH-FORM">
      <form novalidate @submit.prevent="magnify">
        <search-input
            :value="query"
            :results="results"
            :placeholderText="placeholderText"
            @input="search($event)"
            @selected="selectedResultIndex = $event"
            @select="selectedResultIndex = $event"
            @magnify="magnify"
            @clear="clear"
            @click.native="focusSet"/>
      </form>
      <transition name="fade">
        <div
            v-if="focused && query"
            class="RESULTS-CONTAINER"
            selenium="search-results-container">
          <transition name="fade-up">
            <search-results
                v-if="newList && newList.length"
                key="1"
                :services="newList"
                :selected="selectedResultIndex"
                class="RESULTS"
                @select="select"/>
            <div
                v-else-if="!isLoading"
                key="2"
                class="RESULTS p-2 text-center bg-red c-white"
                selenium="no-search-results-text">
              No results found. Please try again.
            </div>
          </transition>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { _debounce } from '@/functions';
import { REMOVED_SERVICE_IDS } from '../../constants';
import SearchResults from './components/SearchResults';
import SearchInput from './components/SearchInput';

export default {
  name: 'service-search-form',
  components: {
    SearchInput,
    SearchResults,
  },
  props: {
    placeholderText: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      selectedResultIndex: -1,
      focused: false,
      newList: [],
    };
  },
  computed: {
    ...mapGetters('homepage/search', [
      'query',
      'results',
      'isLoading',
    ]),
    ...mapGetters('user', [
      'isLoggedIn',
      'me',
      'canSubmitLeads',
    ]),
  },
  watch: {
    results (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setList();
      }
    },
  },
  mounted () {
    if (this.isLoggedIn) {
      this.checkNumberOfLeads();
    }
  },
  methods: {
    ...mapActions('user', ['checkNumberOfLeads']),
    select ($event) {
      this.selectedResultIndex = $event;
      this.$store.commit('homepage/request/setSelectedService', this.newList[this.selectedResultIndex]);
      this.focused = false;
      this.clear();
    },
    setList () {
      const serviceIds = REMOVED_SERVICE_IDS;
      this.newList = this.results.filter(({ service_identifier }) =>
        !serviceIds.includes(service_identifier));
      return this.newList;
    },
    search (query) {
      this.focused = true;
      if (this.isLoggedIn && !this.canSubmitLeads) {
        this.$emit('limitReached');
        this.clear();
      } else {
        this.submitSearch(query);
      }
    },
    submitSearch: _debounce(
      function submitSearch (query) {
        this.$store.dispatch('homepage/search/searchForServices', {
          query,
          size: 10,
        })
          .then(() => {
            const serviceIds = REMOVED_SERVICE_IDS;
            const filterArray = this.results.filter(({ service_identifier }) =>
              !serviceIds.includes(service_identifier));
            const resultsArray = filterArray.map(item => item.id);
            const trackingContext = {
              query: this.query,
              results: resultsArray,
              count: resultsArray.length,
            };
            this.$events.$emit(this.$events.HOMEPAGE_SEARCH, trackingContext);
          });
      },
      300
    ),
    clear () {
      this.$store.dispatch('homepage/search/reset');
      this.selectedResultIndex = -1;
    },

    async magnify () {
      if (this.selectedResultIndex > -1) { // when the user selects a service from the results
        this.select(this.selectedResultIndex);
      } else { // when the user hits enter without a result selected
        this.focused = false;
        this.$store.dispatch('homepage/search/selectQuery');
      }
    },
    focusSet () {
      this.focused = true;
      if (this.isLoggedIn && !this.canSubmitLeads) {
        this.$emit('limitReached');
        this.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$shadow: -2px 2px 3px rgba(0, 0, 0, 0.5);

.SEARCH-FORM {
  border: 1px solid $color-gray40;

}

.RESULTS-CONTAINER {
  position: relative;
}

.RESULTS {
  position: absolute;
  width: 100%;
  z-index: 10;
  max-height: 286px;
  overflow-y: scroll;
  box-shadow: $shadow;
}
</style>
